import { render, staticRenderFns } from "./ButtonType.vue?vue&type=template&id=7cfd0d72"
import script from "./ButtonType.vue?vue&type=script&lang=js"
export * from "./ButtonType.vue?vue&type=script&lang=js"
import style0 from "./ButtonType.vue?vue&type=style&index=0&id=7cfd0d72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports